
<div>
    <!-- contract edit -->
    <d-contract-lim-edit
        v-model      = "edit"
        :type-id     = "contract && contract.type ? contract.type.id : null"
        :contract-id = "contract ? contract.id : null"
        :company-id  = "contract && contract.company ? contract.company.id : null"
        @saved       = "onSaved"
    />
    <!-- contract edit -->

    <c-list-card
        :background = "background"
        :icon       = "icon"
        @edit       = "onEdit"
        @selected   = "onSelected"
    >
        <template v-slot:title>
            <div class="primary--text">
                {{ contract.id }}
            </div>
            <v-spacer/>
            <div class="pr-1 primary--text" v-if="isLim">
                <span>{{ money(contract.pricePerMonth) }}</span>
                <span v-if="contract.lgsPerMonth"> / {{ money(contract.lgsPerMonth) }}</span>
            </div>
            <v-chip
                v-if        = "showTierChip"
                x-small
                :color      = "tierChipColor"
                :text-color = "tierChipTextColor"
                class       = "ml-1"
            >
                {{ contract.tier.name }}
            </v-chip>
            <div class="pr-1 primary--text" v-if="isDls">
                {{ money(contract.netamount) }}
            </div>
        </template>

        <template v-slot:buttons>
            <a @click.stop="onRenew" v-if="isAutorenew && selected && selected.id === contract.id">
                <v-icon
                    color = "primary"
                    size  = "20"
                    style = "margin-top: -2px"
                    class = "toolbar-button"
                >
                    mdi-autorenew
                </v-icon>
            </a>
        </template>

        <template v-slot:body>
            <!-- Invoice recipient -->
            <div v-if="invoice" class="pt-1" >
                <div class="v-flex">
                    <div
                        class = "card-subtitle"
                    >
                        {{ invoice.name }}
                    </div>

                    <v-icon
                        color = "primary"
                        size  = "20"
                        class = "recipient-icon"
                    >
                        mdi-alpha-r-box
                    </v-icon>

                    <v-icon
                        v-if  = "invoice.benefit"
                        color = "primary"
                        size  = "20"
                        class = "recipient-icon"
                    >
                        mdi-alpha-l-box
                    </v-icon>
                    <v-spacer />
                </div>
                <div class="card-subtitle" v-html="toHtml(invoice.nameAdd)"></div>
                <div class="card-subtitle-add">{{ invoice.street }}, {{ invoice.zip }} {{ invoice.city }} </div>
            </div>
            <!-- Invoice recipient -->

            <div v-if="benefit && (!invoice || invoice.id !== benefit.id)" class="pt-0">
                <v-divider class="mt-2 mb-2" />
                <div class="v-flex">
                    <div class="card-subtitle">{{ benefit.name   }} </div>
                    <v-icon color="primary" size="20" class="recipient-icon">mdi-alpha-l-box</v-icon>
                    <v-spacer />
                </div>
                <div class="card-subtitle-add" v-html="toHtml(benefit.nameAdd)"></div>
                <div class="card-subtitle-add">{{ benefit.street }}, {{ benefit.zip }} {{ benefit.city }} </div>
            </div>
        </template>
    </c-list-card>
</div>
